<template>
	<div>
		<FAQ />
		<div class="flex items-center justify-center mb-8 gap-5">
			<a :href="downloadTemplates" download>
				<button
					class="transition-all py-4 ease-in-out duration-150 transform hover:scale-110 bg-blue-500 hover:bg-blue-600 px-10 rounded-lg text-white"
				>
					Скачать шаблоны по движению ТМЗ
				</button>
			</a>
			<a :href="downloadInstructionTmz" download>
				<button
					class="transition-all py-4 ease-in-out duration-150 transform hover:scale-110 bg-blue-500 hover:bg-blue-600 px-10 rounded-lg text-white"
				>
					Скачать инструкцию ТМЗ
				</button>
			</a>
			<a :href="downloadInstruction" download>
				<button
					class="transition-all py-4 ease-in-out duration-150 transform hover:scale-110 bg-blue-500 hover:bg-blue-600 px-10 rounded-lg text-white"
				>
					Скачать инструкцию по металлолому
				</button>
			</a>
			<button
				class="transition-all py-4 ease-in-out duration-150 transform hover:scale-110 bg-blue-500 hover:bg-blue-600 px-10 rounded-lg text-white"
				@click="showContactModal"
			>
				Связаться с нами
			</button>
		</div>
		<div class="learning-module">
			<!-- <div class="learning">
				<div class="learning-left">

					<a :href="downloadTemplates" download>
						<button class="downloadBtnTemplates">
							Скачать шаблоны по движению ТМЗ
						</button>
					</a>
					<a :href="downloadInstructionTmz" download>
						<button class="downloadBtn">
							Скачать инструкцию ТМЗ
						</button>
					</a>
					<a :href="downloadInstruction" download>
						<button class="downloadBtn">Скачать инструкцию</button>
					</a>
				</div>
				<div class="learning-right">
					<img src="@/assets/contact-img.jpg" alt="Learning img" />
					<button class="contract-btn" @click="showContactModal">
						Связаться с нами
					</button>
				</div>
			</div> -->
			<modal class="contact-modal" name="contact-modal">
				<div class="modal-inner">
					<div class="contact-user">
						<a class="mail-link">
              Ay.Sagynzhanova@kmg.kz
						</a>
						<a>+7 7172 78 67 79</a>
					</div>
          <div class="contact-user">
            <a class="mail-link">
              azatbekov@prodev.kz
            </a>
          </div>
<!--					<div class="contact-user">-->
<!--						<a class="mail-link">-->
<!--							as.turgunov@kmg.kz-->
<!--						</a>-->
<!--						<a>+7 7172 95 97 39</a>-->
<!--					</div>-->
<!--					<div class="contact-user">-->
<!--						<a class="mail-link">-->
<!--							sultan.ryspekov@internet.ru-->
<!--						</a>-->
<!--						<a>+7 702 999 65 50</a>-->
<!--					</div>-->
					<!-- <div class="contact-user">
					<a href="mailto:zh.zholamanov@kmg.kz" class="mail-link">
						bagdatov@prodev.kz
					</a>
					<span>+7 700 789 78 33</span>
				</div> -->

					<!-- <ul>
                <li>
              <a href="mailto:zh.zholamanov@kmg.kz" class="mail-link"
                >zh.zholamanov@kmg.kz</a>
            </li>
            <li>
              <a href="mailto:bagdatov@prodev.kz" class="mail-link"
                >bagdatov@prodev.kz</a
              >
            </li>
            <li>
              <a href="mailto:sultan.ryspekov@internet.ru" class="mail-link"
                >sultan.ryspekov@internet.ru</a
              >
            </li>
            </ul> -->
				</div>
			</modal>
		</div>
	</div>
</template>

<script>
import FAQ from '@/components/FAQ';
export default {
	data() {
		return {
			downloadInstruction: `${process.env.VUE_APP_MEDIA_URL}/media/Инструкция_Металл.pdf`,
			downloadInstructionTmz: `${process.env.VUE_APP_MEDIA_URL}/media/Инструкция_ТМЗ.pdf`,
			downloadTemplates: `${process.env.VUE_APP_MEDIA_URL}/media/Шаблоны.rar`,
		};
	},
	components: {
		FAQ,
	},
	methods: {
		showContactModal() {
			this.$modal.show('contact-modal');
		},
		hideContactModal() {
			this.$modal.hide('contact-modal');
		},
	},
};
</script>

<style scoped>
.learning-module {
	display: flex;
	justify-content: center;
	align-items: center;
	/* min-height: 100vh; */
}

.learning {
	display: grid;
	grid-template-columns: 1fr 1fr;
	gap: 1rem;
	padding: 2rem;
}

.learning-left {
	background-image: url('../assets/learning-img.jpg');
	background-position: center;
	border-radius: 30px;
	/* overflow: hidden; */
	/* width: 300px; */
	/* border: 1px solid black; */
	position: relative;
	display: flex;
	flex-direction: column;
	align-items: flex-end;
	justify-content: flex-end;
	padding: 10px;
}

.learning-left img {
	background-size: cover;
	width: 400px;
	border-radius: 30px;
}

.learning-right {
	/* border: 1px solid black; */
	position: relative;
}

.learning-right img {
	width: 400px;
	border-radius: 30px;
}

.downloadBtn {
	margin-top: 1rem;
	padding: 1rem 2rem;
	border: none;
	outline: none;
	border-radius: 10px;
	margin-left: 1rem;
	cursor: pointer;
	font-size: 1.1rem;
	background: #7ad38d;
	color: white;
	/* position: absolute;
	bottom: 20px;
	right: 30px; */
}

.downloadBtnTemplates {
	margin-top: 1rem;
	padding: 1rem 2rem;
	border: none;
	outline: none;
	border-radius: 10px;
	margin-left: 1rem;
	cursor: pointer;
	font-size: 1.1rem;
	background: #7ad38d;
	color: white;
	/* position: absolute;
	bottom: 100px;
	right: 30px; */
	max-width: 200px;
}

.contract-btn {
	margin-top: 1rem;
	padding: 1rem 2rem;
	border: none;
	outline: none;
	border-radius: 10px;
	margin-left: 1rem;
	cursor: pointer;
	font-size: 1.1rem;
	background: #7ad38d;
	color: white;
	position: absolute;
	bottom: 20px;
	left: 30px;
}

.modal-inner {
	height: 100%;
	padding: 1rem;
	display: flex;
	justify-content: center;
	align-items: center;
	flex-direction: column;
	gap: 1rem;
}

.contact-user {
	text-align: center;
	user-select: text;
}

.mail-link {
	text-decoration: none;
	color: black;
	display: block;
}
</style>
